<h2 mat-dialog-title>
  <mat-icon class="material-symbols-outlined">file_download</mat-icon>
  Exportar lançamentos
</h2>

<mat-dialog-content>
  <div class="info-box">
    <p>
      A exportação será gerada com os filtros atualmente aplicados.
      <strong>{{ data.quantidadeRegistros }}</strong> lançamento(s) serão incluídos no arquivo.
    </p>
  </div>

  <div class="layout-box">
    <h3>Colunas do arquivo</h3>
    <div class="chips">
      @for (coluna of data.colunas; track coluna) {
        <span class="chip">{{ coluna }}</span>
      }
    </div>
  </div>

  @if (data.previewRows.length > 0) {
    <div class="preview-box">
      <h3>Pré-visualização</h3>
      <div class="table-responsive">
        <table mat-table [dataSource]="data.previewRows">
          <ng-container matColumnDef="data">
            <th mat-header-cell *matHeaderCellDef>Data</th>
            <td mat-cell *matCellDef="let row">{{ row.data }}</td>
          </ng-container>
          <ng-container matColumnDef="categoria">
            <th mat-header-cell *matHeaderCellDef>Categoria</th>
            <td mat-cell *matCellDef="let row">{{ row.categoria || '-' }}</td>
          </ng-container>
          <ng-container matColumnDef="historico">
            <th mat-header-cell *matHeaderCellDef>Histórico</th>
            <td mat-cell *matCellDef="let row">{{ row.historico || '-' }}</td>
          </ng-container>
          <ng-container matColumnDef="tipo">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let row">{{ row.tipo }}</td>
          </ng-container>
          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef>Valor</th>
            <td mat-cell *matCellDef="let row">{{ row.valor }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      @if (data.quantidadeRegistros > data.previewRows.length) {
        <small class="preview-hint">
          Exibindo os primeiros {{ data.previewRows.length }} registros para conferência.
        </small>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" mat-dialog-close>Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()">Salvar arquivo</button>
</mat-dialog-actions>
